import CargoBar_1 from './CargoBar_1';
import CargoBar_ProteinOcean from './CargoBar_ProteinOcean';
import CargoBar_Yenir from './CargoBar_Yenir';

export const CargoBar = {
  CargoBar_1: ({ item }) => {
    return <CargoBar_1 item={item} />;
  },
  CargoBar_ProteinOcean: ({ item }) => {
    return <CargoBar_ProteinOcean item={item} />;
  },
  CargoBar_Yenir: ({ item }) => {
    return <CargoBar_Yenir item={item} />;
  },
};
